import WeatherApp from "./views";

import "./App.css";

function App() {
  return (
    <div className="App">
      <WeatherApp />
    </div>
  );
}

export default App;
